import { z } from "zod"
import { TranslationKey } from "../i18n/translation-key"

export const SupplierSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  alias: z.array(z.string()),
  logo: z.string().nullable(),
  createdAt: z.date(),
})

export type Supplier = z.infer<typeof SupplierSchema>

export const SaveSupplierSchema = z.object({
  name: z
    .string()
    .min(1, "common.validation.supplierNameRequired" satisfies TranslationKey),
})

export type SaveSupplier = z.infer<typeof SaveSupplierSchema>
